/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInLimitSnapshotAction = typeof LinkedInLimitSnapshotAction[keyof typeof LinkedInLimitSnapshotAction];


export const LinkedInLimitSnapshotAction = {
  connection_requests: 'connection_requests',
  messages: 'messages',
  profile_views: 'profile_views',
} as const;
